<template>
  <div class="container-page">
    <p class="title-inner">Субъекты РФ</p>

    <div class="mb-4">
      <DefaultFilter :filterValue="filter" @loadFilter="onLoadFilter" />
    </div>

    <div class="table-container mb-16 js-table-arrow">
      <table class="stockTable">
        <thead>
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Код региона</th>
            <th scope="col">Название</th>
            <th scope="col">Статус</th>
          </tr>
          <tr>
            <th scope="col" class="filter"></th>
            <th scope="col" class="filter">
              <FilterInput
                v-model="filter.code"
                type="integer"
                placeholder="Найти..."
                @valueChangedDebounced="changeFilter"
              />
            </th>
            <th scope="col" class="filter">
              <FilterInput v-model="filter.name" placeholder="Найти..." @valueChangedDebounced="changeFilter" />
            </th>
            <th scope="col" class="filter">
              <FilterActiveInput v-model="filter.isActive" placeholder="(Все)" @valueChangedDebounced="changeFilter" />
            </th>
          </tr>
        </thead>

        <tbody v-if="page.items?.length && !isLoading">
          <tr v-for="item in page.items" :key="item.id">
            <td>{{ item.blitzId }}</td>
            <td>{{ getRegionCodes(item) }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.isActive ? 'действ.' : 'не действ.' }}</td>
          </tr>
        </tbody>

        <tbody v-else-if="isLoading">
          <tr>
            <td class="text-center" colspan="3">Загрузка...</td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr>
            <td class="text-center" colspan="3">Нет данных.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="page.pagesTotal > 1">
      <Pagination
        :pageCount="page.pagesTotal"
        :currentPage="page.pageNumber"
        @change="onPageChange($event, false)"
        @more="onPageChange($event, true)"
      />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';

  import DefaultFilter from '@/common/components/DefaultFilter';
  import FilterActiveInput from '@/common/components/FilterActiveInput';
  import FilterInput from '@/common/components/FilterInput';
  import Constants from '@/common/constants';
  import { DEFAULT_PAGINATION_PAGE } from '@/common/constants/page';
  import { loadFilter, saveFilter } from '@/common/utils/filterManager';

  import { DIRECTIVES_ACTIONS_NAME, DIRECTIVES_GETTERS_NAME, DIRECTIVES_MUTATIONS_NAME } from '@/store/directives';

  const getInitialFilter = () => ({
    name: null,
    code: null,
    isActive: null,
  });

  export default {
    name: 'SubjectRF',
    components: {
      DefaultFilter,
      FilterInput,
      FilterActiveInput,
    },

    data() {
      return {
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
        },
        filter: getInitialFilter(),
        isLoading: false,
      };
    },

    computed: {
      ...mapGetters({
        regionsPageFromStore: DIRECTIVES_GETTERS_NAME.getRegionsPage,
      }),

      page() {
        const page = this.regionsPageFromStore;

        if (!page) return { ...DEFAULT_PAGINATION_PAGE };

        return {
          ...DEFAULT_PAGINATION_PAGE,
          ...page,
          items: Array.isArray(page.items) ? page.items : [],
        };
      },
    },

    created() {
      this.initPage();
    },

    methods: {
      ...mapActions({
        searchRegionsPage: DIRECTIVES_ACTIONS_NAME.getRegionsPage,
      }),

      ...mapMutations({
        setRegionsPageMutation: DIRECTIVES_MUTATIONS_NAME.setRegionsPage,
      }),

      async initPage() {
        const savedFilter = await loadFilter(this.$options.name);

        if (savedFilter)
          this.filter = {
            ...getInitialFilter(),
            ...savedFilter,
          };

        this.loadPage(false);
      },

      getPreparedRequest() {
        const request = {
          pageNumber: this.request.pageNumber,
          pageSize: this.request.pageSize,
        };

        const name = this.filter.name?.trim?.();
        if (name) request.name = name;

        if (this.filter.code !== null && this.filter.code !== undefined && this.filter.code !== '')
          request.code = Number(this.filter.code);

        if (typeof this.filter.isActive === 'boolean') request.isActive = this.filter.isActive;

        return request;
      },

      async loadPage(append) {
        this.isLoading = !append;

        const request = this.getPreparedRequest();

        try {
          const response = await this.searchRegionsPage({
            params: request,
          });

          if (!response?.success || !response?.data) return;

          let nextPage = response.data;

          if (append)
            nextPage = {
              ...response.data,
              items: [...this.page.items, ...(response.data.items || [])],
              firstItemNumber: this.page.firstItemNumber || response.data.firstItemNumber,
            };

          this.setRegionsPageMutation({ data: nextPage });
        } finally {
          this.isLoading = false;
        }
      },

      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },

      changeFilter() {
        this.request.pageNumber = 1;
        saveFilter(this.$options.name, this.filter);
        this.loadPage(false);
      },

      onLoadFilter(item) {
        this.filter = {
          ...getInitialFilter(),
          ...(item || {}),
        };
        this.changeFilter();
      },

      getRegionCodes(item) {
        if (!Array.isArray(item?.regionCodes) || !item.regionCodes.length) return '';

        return item.regionCodes.join(', ');
      },
    },
  };
</script>
